import { currentLanguage, LOCALES } from "@/i18n";
import type { OrderStatus } from "@/lib/api";

export function formatMoney(amount: number, currency: string): string {
  try {
    return new Intl.NumberFormat(LOCALES[currentLanguage()], { style: "currency", currency }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency}`;
  }
}

export function formatDate(iso: string, withTime = false): string {
  return new Intl.DateTimeFormat(LOCALES[currentLanguage()], {
    dateStyle: "medium",
    ...(withTime ? { timeStyle: "short" } : {}),
  }).format(new Date(iso));
}

/** Badge colours per order status. */
export const STATUS_STYLES: Record<OrderStatus, { className: string; icon: string }> = {
  paid: { className: "bg-accent-100 text-accent-900", icon: "ri-checkbox-circle-line" },
  pending_payment: { className: "bg-amber-100 text-amber-800", icon: "ri-time-line" },
  cancelled: { className: "bg-red-100 text-red-700", icon: "ri-close-circle-line" },
  refunded: { className: "bg-background-200 text-foreground-700", icon: "ri-refund-2-line" },
};
